export class Parameter {
    constructor(variable, range, required, description, deprecated) {
        this.variable = variable;
        this.range = range;
        this.required = required;
        this.description = description;
        this.deprecated = deprecated;
    }
}
//# sourceMappingURL=Parameter.js.map